package team.platforma.multiplatform_material_extension.util.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.focus.FocusRequester
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
@Deprecated("")
@Composable
fun rememberForms(): State<Forms> {
    val coroutineScope = rememberCoroutineScope()
    return remember { mutableStateOf(Forms(coroutineScope)) }
}

@Composable
fun Forms.isChanged(): Boolean {
    return this.changeForm.collectAsState().value
}

@Composable
fun Forms.isValid(): Boolean {
    return this.validForm.collectAsState().value
}

fun Forms.validateForm(boolean: Boolean) {
    this.validateAllForm(boolean)
}

fun Forms.setValidateByKey(key: String, boolean: Boolean) {
    this.setValidateByKey(key, boolean)
}

fun Forms.setLogEnabled(boolean: Boolean) {
    this.logEnabled = boolean
}

class Forms(private val coroutineScope: CoroutineScope) {
    private val _initValueMap: MutableMap<String, String> = mutableMapOf()

    //    private val _requiredMap: MutableMap<String, Boolean> = mutableMapOf()
    private val _changeMap: MutableStateFlow<MutableMap<String, String>> =
        MutableStateFlow(mutableMapOf())
    private val _validateMap: MutableStateFlow<MutableMap<String, Boolean>> =
        MutableStateFlow(mutableMapOf())

    internal val changeForm: StateFlow<Boolean> = _changeMap
        .map { currentMutableMap ->
            _initValueMap.entries.any { (key, value) ->
                currentMutableMap[key] != value
            }
        }
        .stateIn(
            scope = coroutineScope,
            started = SharingStarted.Eagerly,
            initialValue = false
        )

    internal val validForm: StateFlow<Boolean> = _validateMap
        .map { mutableMap -> mutableMap.values.all { it } }
        .stateIn(
            scope = coroutineScope,
            started = SharingStarted.Eagerly,
            initialValue = false
        )


    internal fun initValue(key: String, value: String) {
        _initValueMap += (key to value)
        if (logEnabled) {
            println("Init map: $_initValueMap")
        }
    }

//    internal fun setRequired(key: String, boolean: Boolean) {
//        _requiredMap += (key to boolean)
//        if (logEnabled) {
//            println("Required map: $_requiredMap")
//        }
//    }

    internal fun changeValue(key: String, value: String) {
        _changeMap.update { currentState ->
            currentState.toMutableMap().apply { this[key] = value }
        }
        if (logEnabled) {
            coroutineScope.launch {
                _changeMap.collect {
                    println("Change map: $it")
                }
            }
        }

    }

    internal fun setValidateState(key: String, boolean: Boolean) {
        _validateMap.update { currentState ->
            currentState.toMutableMap().apply { this[key] = boolean }
        }
        if (logEnabled) {
            coroutineScope.launch {
                _validateMap.collect {
                    println("Validate map: $it")
                }
            }
        }
    }

    internal fun validateAllForm(boolean: Boolean) {
        val map = _validateMap.value.mapValues { boolean }
        _validateMap.update {
            it.toMutableMap().apply {
                putAll(map)
            }
        }
    }

    internal fun setValidateByKey(key: String, boolean: Boolean) {
        _validateMap.update { currentState ->
            currentState.toMutableMap().apply { this[key] = boolean }
        }
    }

    internal var logEnabled = false

    private var focusIndex = 0

    private val _focusMap: MutableStateFlow<MutableMap<Int, FocusRequester>> =
        MutableStateFlow(mutableMapOf())

    internal fun registerFocus(focusRequester: FocusRequester): Int {
        _focusMap.update { map ->
            map.toMutableMap().apply {
                this[focusIndex] = focusRequester
                focusIndex++
            }
        }
        return focusIndex - 1
    }

    internal fun moveToNextFocus(currentIndex: Int) {
        _focusMap.value.let { map ->
            val nextIndex = (currentIndex + 1) % map.size
            map[nextIndex]?.requestFocus()
        }
    }
}

